export enum COMPANY_STATUS {
  TRIAL = 'TRIAL',
  FREE = 'FREE',
  ACTIVE = 'ACTIVE',
  AWAITING_FOR_PAYMENT = 'AWAITING_FOR_PAYMENT',
  BLOCKED = 'BLOCKED'
}
